import React from 'react';
import { TagOutlined, UsergroupAddOutlined, CreditCardOutlined, SendOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';
import SwitchShop from '../shop/switch-shop';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        <SwitchShop />
        
        {/* 快捷操作 - iOS 风格图标组 */}
        <div className="mt-3 mb-4">
            <AppIconGroup 
                items={[
                    {
                        id: 1,
                        href: '/promotion/goods-card-template',
                        title: '次卡',
                        icon: <CreditCardOutlined />,
                        color: 'from-blue-500 to-blue-600'
                    },
                    {
                        id: 2,
                        href: '/promotion/group-buy',
                        title: '团购',
                        icon: <UsergroupAddOutlined />,
                        color: 'from-green-500 to-green-600'
                    },
                    {
                        id: 3,
                        href: '/promotion/coupon',
                        title: '优惠券',
                        icon: <TagOutlined />,
                        color: 'from-purple-500 to-purple-600'
                    },
                    {
                        id: 4,
                        href: '/promotion/sms',
                        title: '短信营销',
                        icon: <SendOutlined />,
                        color: 'from-orange-500 to-orange-600'
                    }
                ]}
                cols="4-4-4-4-4"
            />
        </div>
    </div>
  )
}